import { usePlatformGet } from '@reapitform/hooks'

export const useAgreementPdf = (agreementId?: string) => {
  const path: string = `/api/Document/${agreementId}/PDF`
  const [result, loading, errorString] = usePlatformGet<string>({
    path,
    retry: false,
    fetchWhenTrue: [agreementId !== undefined],
  })

  const data = result ?? null

  return { data, loading, errorString }
}
